module.exports = __webpack_public_path__ + "img/fif-questions.bf1a97e8.png";